import { type ReduxStateShared } from '~shared/types';

const getSelectedPaymentTypes = (state: ReduxStateShared) => state.checkout.checkout.selected_payment_types;

export default getSelectedPaymentTypes;
